import { DATAGRID_FOOTER_HEIGHT, LEADS_TABLE_ADJUSTED_HEIGHT } from '@constants/common';
import { skipForwardProp } from '@utils/styled';

import { Box, BoxProps, GridProps, IconButton, IconButtonProps } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';

export const StyledLeadsBox = styled(Box)<BoxProps & { theme?: Theme }>(() => ({
  borderLeft: '1px solid var(--sk-surface-border)',
  width: 'calc(100% - 250px)',
}));

export const StyledSmartHeightDataGridContainer = styled(Box, {
  shouldForwardProp: skipForwardProp(['expanded', 'headerAppHeight']),
})<GridProps & { headerAppHeight: number; expanded?: boolean }>(({ headerAppHeight, expanded }) => ({
  height: `calc(100vh - ${headerAppHeight}px - ${LEADS_TABLE_ADJUSTED_HEIGHT}px - ${DATAGRID_FOOTER_HEIGHT}px)`,
  width: expanded ? 'calc(100% - 250px)' : '100%',
}));

export const StyledSmartHeightFiltersContainer = styled(Box, {
  shouldForwardProp: skipForwardProp('headerAppHeight'),
})<GridProps & { headerAppHeight: number }>(({ headerAppHeight }) => ({
  height: `calc(100vh - ${headerAppHeight}px - ${LEADS_TABLE_ADJUSTED_HEIGHT}px - ${DATAGRID_FOOTER_HEIGHT}px)`,
  overflowY: 'auto',
}));

export const StyledIconButton = styled(IconButton)<IconButtonProps>({
  color: 'var(--sk-text-secondary)',
  '&.MuiIconButton-root:hover': {
    backgroundColor: 'var(--sk-surface-hover)',
    color: 'var(--sk-text-primary)',
  },
});
